<template>
	<page class="d-flex justify-center align-center flex-column">
		<project-form />
		<project />
		<project-subscription />
		<tracks-view />
	</page>
</template>

<script>
import Project from "./Project";
import ProjectForm from "./ProjectForm.vue";
import ProjectSubscription from "./ProjectSubscriptions";
import TracksView from "../tracks/TracksView";
export default {
	name: "ProjectMultiEdit",
	components: { Project, ProjectSubscription, ProjectForm, TracksView }
};
</script>

<style scoped></style>
